import type { State } from './types';

export const initialState: State = {
	view: null,
	isFullscreen: false,
	showEpicPanel: false,
	showVersionPanel: false,
	showQuickFilters: false,
	showEpics: true,
	showStatuses: true,
	showVersions: true,
	showCompactMode: false,
	showUnscheduledColumn: true,
	showIssueLinksStats: false,
	showIssueKey: true,
	showIssueType: true,
	showEstimate: true,
	showAssignee: true,
	showPriority: true,
	showDaysInColumn: true,
	showDueDate: true,
	showLabels: true,
	cardExtraFields: {},
};

export const VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID =
	'view-settings.ui.panel.header.close-button';
export const VIEW_SETTINGS_BUTTON_LG = 'view-settings-show-button.ui.view-settings-button-large';
export const VIEW_SETTINGS_BUTTON_SM = 'view-settings-show-button.ui.view-settings-button-small';
export const VIEW_SETTINGS_BUTTON_RESPONSIVE =
	'view-settings-show-button.ui.view-settings-button-responsive';

export const QUERY_ENABLED_VALUE = 'on';
export const QUERY_DISABLED_VALUE = 'off';
